import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class StringUtilsService {
  constructor() {}

  capitalize(value: string): string {
    return value ? value.charAt(0).toUpperCase() + value.slice(1) : null;
  }

  formatEuro(value: number): string {
    return Number(value).toLocaleString("it-IT", {
      minimumFractionDigits: 2,
    });
  }
}
